import { createContext, Context } from 'react';
import type ShowInViewMetadata from './interfaces/ShowInViewMetadata';

export interface ShowInViewMetadataContext extends Context<ShowInViewMetadata> {
  displayName: 'ShowInViewMetadata';
}

export const defaultShowInViewMetadata: ShowInViewMetadata = {
  resetScrollPositionRef: null,
  skipScrollRef: null,
  ongoingTasksCounterRef: null,
};

const showInViewMetadataContext = createContext<ShowInViewMetadata>(defaultShowInViewMetadata);
showInViewMetadataContext.displayName = 'ShowInViewMetadata';

export default showInViewMetadataContext;
